import { useState, useCallback } from "react"
import { BadgeElementType, BadgeTemplate } from "sharedTypes/badge"

/**
 * Manages inline text editing state
 */
const useInlineEditing = (
  setSelectedElementId: (id: string) => void,
  getTemplate: () => BadgeTemplate,
) => {
  const [inlineEditingElementId, setInlineEditingElementId] = useState<string | undefined>()

  const startInlineEditing = useCallback((elementId: string) => {
    const element = getTemplate().badgeData.elements.find((el) => el.id === elementId)
    if (element && element.type === BadgeElementType.TEXT) {
      setInlineEditingElementId(elementId)
      setSelectedElementId(elementId)
    }
  }, [getTemplate, setSelectedElementId])

  const stopInlineEditing = useCallback(() => {
    setInlineEditingElementId(undefined)
  }, [])

  return {
    inlineEditingElementId,
    startInlineEditing,
    stopInlineEditing,
    setInlineEditingElementId,
  }
}

export default useInlineEditing
